define('components/loader/Loader', [
    'components/loader/models/LoaderModel',
    'components/loader/views/LoaderView'
], function(LoaderModel, LoaderView) {

    var model = null;
    var view = null;
    var options = {};
    var started = false;
    var currentWeight = 0;
    var totalWeight = 0;
    var tasks = [];
    var weights = [];
    var tasksByChannel = {};
    var progressCallback = null;
    var index = 0;
    var debug = false;
    var loader = {
        "$percentage": $({ "percentage": 0 }),
        "progress": 0,
        "currentPercent": 0,
        "tween": null
    };

    var initialize = function(_options) {
        options = _options;
        debug = options.debug || false;

        if (options.defaultView) {
            model = new LoaderModel({
                "imageUrl": options.imageUrl,
                "propertiesUpdated": options.propertiesUpdated
            });

            view = new LoaderView({ "model": model });
            $('#maz-dior-content').before(view.render().$el);
        }
    };

    var addTask = function(taskLabel, task, weight, channel) {
        if (started) {
            if( debug ){
                console.warn("[Loader -> addTask] Loader already started, can't add task", taskLabel);
            }
            return;
        }

        totalWeight += weight;
        weights.push(0);
        tasks.push({ "taskLabel": taskLabel, "index": index++, "task": task, "weight": weight, "channel": channel });
    };

    var start = function(_progressCallback) {
        started = true;

        progressCallback = _progressCallback;
        tasksByChannel = _.groupBy(tasks, function(task) { return task.channel; } );

        _.each(tasksByChannel, function(item, index) {
            executeSynchronousFunctions(index, 0);
        });
    };

    var executeSynchronousFunctions = function(channel, index) {
        if (tasksByChannel[channel].length <= index) {
            if( debug ){
                console.warn("[Loader -> executeSynchronousFunctions] No more tasks in this channel");
            }
            return;
        }

        var item = tasksByChannel[channel][index];

        item.task(function( _taskPercentage ) {
            weights[item.index] = ( item.weight * _taskPercentage / 100 );
            currentWeight = _.reduce(weights, function(memo, num){ return memo + num; }, 0);
            var percentage = Math.round(currentWeight * 100 / totalWeight);
            onProgress(percentage);
            progressCallback(percentage, item.taskLabel);
            if( _taskPercentage === 100 ){
                if( debug ){
                    console.log('[Loader -> executeSynchronousFunctions] Task ' + item.taskLabel + ' finished');
                }
                executeSynchronousFunctions(channel, ++index);
            }
        });
    };

    var onProgress = function(_percentage) {

        loader.currentPercent = _percentage;

        loader.$percentage.stop().animate({ "percentage": loader.currentPercent }, {
            duration: options.animationDuration ? options.animationDuration : 2000,
            easing: options.animationEasing ? options.animationEasing : "swing",
            step: function(val) {
                loader.progress = val;
                if (model) {
                    model.set('percentage', loader.progress);
                }
                if (options.onAnimationStepCallback) {
                    options.onAnimationStepCallback(Math.round(loader.progress), Math.round(loader.currentPercent));
                }
            },
            complete: function() {
                if (loader.progress >= 100) {
                    if (view) {
                        view.remove();
                    }
                    if (options.onAnimationCompleteCallback) {
                        options.onAnimationCompleteCallback();
                    }
                }
            }
        });
    };

    return {
        initialize: initialize,
        addTask: addTask,
        start: start
    };
});
